import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { Box, Flex, Text, Icon } from '@qga/roo-ui/components';
import NextLink from './NextLink';
import PreviousLink from './PreviousLink';
import Summary from './Summary';
import PageLinks from './PageLinks';
import { useDataLayer } from 'hooks/useDataLayer';
import { SORTS_BY_CODE } from 'lib/enums/search';

const Pagination = ({ pageSize, total, showSortOrder = false, ...rest }) => {
  const { pathname, query } = useRouter();
  const { emitInteractionEvent } = useDataLayer();

  const page = Number(query.page) || 1;
  const offset = pageSize * page - pageSize;
  const from = offset + 1;
  const to = from + pageSize - 1;
  const sortByName = SORTS_BY_CODE[query.sortBy]?.name;

  const onClick = (page) => {
    emitInteractionEvent({ type: 'Page Number', value: `Page ${page}` });
  };

  return (
    <Flex
      flexDirection={['column', 'row', 'row']}
      justifyContent={['center', 'space-between', 'space-between']}
      width="100%"
      {...rest}
      data-testid="pagination"
    >
      <Flex justifyContent="center">
        <Summary from={from} to={to} total={total} />

        {showSortOrder && sortByName && (
          <Flex py={1}>
            <Box mx={2}>
              <Icon name="circle" color="greys.charcoal" size={4} />
            </Box>
            <Text data-testid="sorted-by">Sorted by {sortByName}</Text>
          </Flex>
        )}
      </Flex>

      <Flex alignItems="center" justifyContent="center" mt={[5, 0, 0]} ml={5}>
        <PreviousLink page={page} pathname={pathname} currentQuery={query} onClick={onClick} role="link" />
        <PageLinks page={page} pathname={pathname} currentQuery={query} pageSize={pageSize} total={total} onClick={onClick} role="link" />
        <NextLink page={page} pathname={pathname} currentQuery={query} pageSize={pageSize} total={total} onClick={onClick} role="link" />
      </Flex>
    </Flex>
  );
};

Pagination.propTypes = {
  total: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  showSortOrder: PropTypes.bool,
};

Pagination.defaultProps = {
  showSortOrder: false,
};

export default Pagination;
